import { render, staticRenderFns } from "./OtherCountryModal.vue?vue&type=template&id=3520c04e&scoped=true&"
import script from "./OtherCountryModal.vue?vue&type=script&lang=ts&"
export * from "./OtherCountryModal.vue?vue&type=script&lang=ts&"
import style0 from "./OtherCountryModal.vue?vue&type=style&index=0&id=3520c04e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3520c04e",
  null
  
)

export default component.exports